import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';
import fixOverlay from './zh-TW/fix_overlay';
import fixOpenapi from './zh-TW/fix_openapi';
import fixAdminMisc from './zh-TW/fix_adminmisc';
import fixBilling from './zh-TW/fix_billing';
import fixComponents from './zh-TW/fix_components';
import fixConsoleMisc from './zh-TW/fix_consolemisc';
import fixGap from './zh-TW/fix_gap';
import fixSystemconfig from './zh-TW/fix_systemconfig';
import fixTenant from './zh-TW/fix_tenant';
import fixVoiceClone from './zh-TW/fix_voiceclone';
import fixTodo from './zh-TW/fix_todo';


export default {
  'navBar.lang': '語言',
  'layout.user.link.help': '幫助',
  'layout.user.link.privacy': '隱私',
  'layout.user.link.terms': '條款',
  'app.preview.down.block': '下載此頁面到本地項目',
  'app.welcome.link.fetch-blocks': '獲取所有塊',
  'app.welcome.link.block-list': '基于 block 開發，快速構建標準頁面',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
};
